import { cva } from "class-variance-authority";

export type CvaConfig = {
  variant: {
    h1: string;
    h2: string;
    h3: string;
    h4: string;
    h5: string;
    h6: string;
    subtitle1: string;
    subtitle2: string;
    body1: string;
    body2: string;
    button: string;
    caption: string;
    overline: string;
  };
};

export const typography: ReturnType<typeof cva<CvaConfig>> = cva(
  "dark:text-white",
  {
    variants: {
      variant: {
        h1: "font-bold text-[4rem] leading-[4.25rem]",
        h2: "font-bold text-[3rem] leading-[3.75rem]",
        h3: "font-semibold text-[3em] leading-[3.125rem]",
        h4: "font-semibold text-[2.25rem] leading-[2.5rem]",
        h5: "font-semibold text-[2.25rem] leading-[2.5rem]",
        h6: "font-normal text-[1.5rem] leading-[1.625rem]",
        subtitle1: "font-bold text-[1rem] leading-[1.25rem]",
        subtitle2: "font-bold text-[0.875rem] leading-[1.125rem]",
        body1: "font-normal text-[1rem] leading-[1.25rem] tracking-[0.002em]",
        body2:
          "font-normal text-[0.875rem] leading-[1.125rem] tracking-[0.002em]",
        button:
          "font-normal text-[0.875rem] leading-[1.125rem] tracking-[0.0025em]",
        caption:
          "font-normal text-[0.75rem] leading-[1.125rem] tracking-[0.002em]",
        overline:
          "font-normal text-[0.75rem] leading-[0.75rem] tracking-[0.02em] uppercase",
      },
    },
    defaultVariants: {
      variant: "body1",
    },
  }
);
